import axios from "axios"
import qs from "querystring"
import { push } from "react-router-redux"
import { call, put, takeLatest } from "redux-saga/effects"
import { fetchCodeTables } from "../../common/redux/fetchCodeTables"
import { fetchAllLg } from "../../home/redux/fetchAllLg"
import { AUTH_LOGIN_BEGIN, AUTH_LOGIN_DISMISS_ERROR, AUTH_LOGIN_FAILURE, AUTH_LOGIN_SUCCESS } from "./constants"
import { fetchUserinfo } from "./fetchUserinfo"

export function login(formValues) {
  return {
    type: AUTH_LOGIN_BEGIN,
    data: formValues,
  }
}

export function dismissLoginError() {
  return {
    type: AUTH_LOGIN_DISMISS_ERROR,
  }
}

// worker Saga: will be fired on AUTH_LOGIN_BEGIN actions
export function* doLogin({ data: { username, password } }) {
  const { response, error } = yield call(oauthLogin, { username, password })

  if (response) {
    const authToken = response.access_token

    yield put({
      type: AUTH_LOGIN_SUCCESS,
      data: { username, authToken },
    })

    yield put(fetchUserinfo(authToken))
    yield put(fetchCodeTables())
    yield put(fetchAllLg(authToken))

    yield put(push("/")) // Maybe it's even better without this :)
  } else {
    yield put({
      type: AUTH_LOGIN_FAILURE,
      data: { error },
    })
  }
}

export function oauthLogin({ username, password }) {
  const tokenEndpoint = process.env.REACT_APP_OAUTH_TOKEN_ENDPOINT

  const params = qs.stringify({
    client_id: "eSchadensmeldung-0a909c7f-1e65-4a40-ae01-6b5a435ac769",
    scope: "Management",
    grant_type: "password",
    username,
    password,
  })

  const config = {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded;charset=utf-8",
    },
  }

  return axios
    .post(tokenEndpoint, params, config)
    .then(response => ({ response: response.data }))
    .catch(error => ({ error: convertOAuthError(error) }))
}

function convertOAuthError(axiosError) {
  if (axiosError.response) {
    const { error, error_description } = axiosError.response.data
    return { code: error, message: error_description }
  } else {
    return { code: "network_error" }
  }
}

/*
  Alternatively you may use takeEvery.

  takeLatest does not allow concurrent requests. If an action gets
  dispatched while another is already pending, that pending one is cancelled
  and only the latest one will be run.
*/
export function* watchLogin() {
  yield takeLatest(AUTH_LOGIN_BEGIN, doLogin)
}

// Redux reducer
export function reducer(state, action) {
  switch (action.type) {
    case AUTH_LOGIN_BEGIN:
      return {
        ...state,
        loginPending: true,
        loginError: null,
      }

    case AUTH_LOGIN_SUCCESS:
      return {
        ...state,
        ...action.data,
        loginPending: false,
        loginError: null,
      }

    case AUTH_LOGIN_FAILURE:
      return {
        ...state,
        loginPending: false,
        loginError: action.data.error,
      }

    case AUTH_LOGIN_DISMISS_ERROR:
      return {
        ...state,
        loginError: null,
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/features/auth/redux/login.js